var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tab",class:{
        'tab_active': _vm.layout === _vm.type
    },on:{"click":function($event){return _vm.$emit('changeLayout', _vm.type)}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }